<script lang="ts" setup>
import AppHeader from '@/components/layout/AppHeader/index.vue'
import PageContainer from '@/components/layout/PageContainer.vue'
import { networks, projectId } from '@/utils/config'
import { EthersAdapter } from '@reown/appkit-adapter-ethers'
import { createAppKit, useAppKitAccount, useAppKitNetwork } from '@reown/appkit/vue'

import { Toast } from 'primevue'
import { computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAccountStore } from './store/account'
import { useBridgeStore } from './store/bridge'
import { useStakeStore } from './store/stake'
import { isProd } from './utils'

const accountStore = useAccountStore()
const stakeStore = useStakeStore()
const bridgeStore = useBridgeStore()
const route = useRoute()

// 2. Create a metadata object
const metadata = {
  name: 'Astake',
  description: 'Astar Liquid Staking',
  url: isProd ? 'https://www.astake.dev/' : 'https://main.dvxtv50zqakkw.amplifyapp.com/', // origin must match your domain & subdomain
  // url: isProd ? 'https://www.astake.dev/' : 'http://localhost:5173', // origin must match your domain & subdomain
  icons: ['https://astakes-organization.gitbook.io/~gitbook/image?url=https%3A%2F%2F2666812556-files.gitbook.io%2F%7E%2Ffiles%2Fv0%2Fb%2Fgitbook-x-prod.appspot.com%2Fo%2Forganizations%252FddI1D9r21GRecdm9xcD3%252Fsites%252Fsite_dWvEe%252Ficon%252FLHqF5XEjRGJiHIIm1Ygy%252Flogo_black.png%3Falt%3Dmedia%26token%3Dea18a3c4-13de-41c9-be85-e9c5de45a775&width=32&dpr=2&quality=100&sign=420fdfbc&sv=2'],
}

// 5. Create the modal
const appKit = createAppKit({
  adapters: [new EthersAdapter()],
  networks,
  projectId,
  metadata,
  themeMode: 'light',
  features: {
    email: false,
    socials: [],
  },
})

const networkData = useAppKitNetwork()
const accountData = useAppKitAccount()

const chainId = computed(() => networkData.value.chainId as number)
const accountAddress = computed(() => accountData.value?.address || '')

watch(
  [accountAddress, chainId],
  ([newAddress, newChainId], [oldAddress, oldChainId]) => {
    console.log('Address changed:', { newAddress, oldAddress })
    console.log('Chain ID changed:', { newChainId, oldChainId })
    // 如果地址或链 ID 有变化
    if (newAddress !== oldAddress || newChainId !== oldChainId) {
      // 确保地址存在
      if (newAddress) {
        accountStore.changeAccount(newAddress)
      }

      // 如果链 ID 改变了，可能需要额外处理
      if (newChainId !== oldChainId) {
        console.log('newChainId', newChainId)
        // 处理链切换逻辑
        accountStore.setNetwork(Number(newChainId))
        accountStore.getPrice()
        accountStore.getTotalStake()
      }
      if (newAddress && newChainId) {
        accountStore.startPolling()

        bridgeStore.getAllowance()
      }
    }
  },
  {
    // 可选配置
    immediate: true, // 立即执行一次
    deep: true, // 深度监听
  },
)

onMounted(async () => {
  accountStore.getApr()
})
// 组件卸载时停止轮询
onUnmounted(() => {
  accountStore.stopPolling()
})

console.log(route, 'route.path')
</script>

<template>
  <div class="font-urw">
    <router-view v-if="route.path === '/'" v-slot="{ Component }">
      <keep-alive :include="['home']">
        <component :is="Component" :key="$route.fullPath" />
      </keep-alive>
    </router-view>
    <PageContainer v-else>
      <div class="relative overflow-hidden">
        <div class="lg:px-[120px] lg:pt-6">
          <AppHeader />
        </div>
        <router-view v-slot="{ Component }">
          <keep-alive :include="['home']">
            <component :is="Component" :key="$route.fullPath" />
          </keep-alive>
        </router-view>
      </div>
    </PageContainer>

    <Toast
      :pt="{
        root: 'w-[20rem]',
        message: 'bg-white border border-black rounded-[12px]',
        closeIcon: 'text-black',
      }" position="bottom-right"
    >
      <template #message="{ message }">
        {{ console.log(message, 'slotProps') }}
        <div class="toast-message flex w-full gap-2" :class="[message.severity]">
          <img
            v-if="message.severity === 'success'" class="relative top-2 h-5 w-5" src="@img/icon/success.png"
            alt=""
          />
          <img v-if="message.severity === 'error'" class="relative top-2 h-5 w-5" src="@img/icon/error.png" alt="" />
          <div>
            <h3
              class="p1 font-semibold" :class="{
                'text-[#11A24D]': message.severity === 'success',
                'text-[#E3351D]': message.severity === 'error',
              }"
            >
              {{ message.summary }}
            </h3>
            <p class="p3">
              {{ message.detail }}
            </p>
          </div>
        </div>
      </template>
    </Toast>
  </div>
</template>

<style lang="less"></style>
